import { useContext, useEffect } from 'react';

import {
  TableContentContext,
  TableContentType,
} from '../context/TableContentContext.jsx';

export const useTableContentContext = (contextProps: TableContentType) => {
  const { setTableContent } = useContext(TableContentContext) || {};

  useEffect(() => {
    setTableContent?.(contextProps);
  }, Object.values(contextProps));
};
